import axios from 'axios';
import { getUrlParamsFromJson, handleCheckAutoLogin } from '../helper/helper';
import { deleteItemCookie } from '@/utils/cookie';
import _ from 'lodash';
import { IS_UPDATE_VERSION_3_PROJECT, IS_UPDATE_VERSION_3_PROJECT_LOGIN } from '@/helper/const';
import { useNavigate } from 'react-router';
import PATH from './PATH';

axios.defaults.timeout = 15000;

const isTimeoutError = (error) =>
  error?.code === 'ECONNABORTED' || /timeout/i.test(error?.message || '');

// Server sập/không nhận được request: mất kết nối tới backend (ERR_NETWORK,
// connection refused — không có error.response) hoặc backend trả lỗi 5xx.
const isServerDownError = (error) =>
  (!error?.response && error?.code === 'ERR_NETWORK') ||
  (+error?.response?.status >= 500);

const notifyConnectionTimeout = () => {
  window.dispatchEvent(new CustomEvent('app:connection-timeout'));
};

const notifyServerDown = () => {
  window.dispatchEvent(new CustomEvent('app:server-down'));
};

axios.interceptors.request.use(
  function (config) {
    let token = getCookie("token") || "";
    const language = localStorage.getItem("language") || localStorage.getItem("i18nextLng");
    config.headers.Authorization = `Bearer ${token}`;
    config.headers.language = !IS_UPDATE_VERSION_3_PROJECT ? "my" : language;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  },
);

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}

export const getDataApi = async (url = '', query = {}) => {
  const queryString = getUrlParamsFromJson(query);
  const urlApi = queryString ? `${url}?${queryString}` : url;
  try {
    const dataApi = await axios.get(urlApi);

    return dataApi?.data;
  } catch (error) {
    console.log(url, error);
    if (isTimeoutError(error)) {
      notifyConnectionTimeout();
      return error;
    }
    if (isServerDownError(error)) {
      notifyServerDown();
      return error;
    }
    if (+error?.response?.status === 401) {
      const url = window.location.href;
      if (_.includes(url, "login") || _.includes(url, "mini-game") || handleCheckAutoLogin()) { // nếu là auto login thì không được refresh token
        return error;
      } else {
        deleteItemCookie("token");
        deleteItemCookie("isLoggedIn");
        deleteItemCookie("isdn");
        localStorage.removeItem("login_with_app");
        localStorage.removeItem("typeUser");
        localStorage.removeItem("msisdn");
        localStorage.removeItem("login_with_app");
        if (IS_UPDATE_VERSION_3_PROJECT_LOGIN) {
          // window.location.href = "/";
        } else {
          window.location.href = "/login";
        }
      }
    }
    return error;
  }
};

export const postDataApi = async (url = "", body = {}, query = {}) => {
  const queryString = getUrlParamsFromJson(query);
  const urlApi = queryString ? `${url}?${queryString}` : url;
  try {
    const { data } = await axios.post(urlApi, body);
    return data;
  } catch (error) {
    console.log(error);
    if (isTimeoutError(error)) {
      notifyConnectionTimeout();
    } else if (isServerDownError(error)) {
      notifyServerDown();
    }
    return error;
  }
};